import { components } from "react-select";
import styled from "styled-components";
const Styles = styled.div`
  display: flex;
  align-items: flex-end;
  padding: 0 6px;
  background-color: #e5e6e6;
  border-radius: 2px;
  font-size: 23px;
  color: #707070;
  margin: 0 2px;
  height: 24px;
  padding-bottom: 3px;
`;
export const MultiValue = (props) => {
  const {
    data,
    index,
    getValue,
    showEllipsis = false,
    maxDisplayedItems = 2,
    truncateLength = 8,
  } = props;
  const selectedValues = getValue();
  const selectedCount = selectedValues.length;

  if (selectedCount === 1) {
    return (
      <components.MultiValue {...props}>
        <span>{data.label}</span>
      </components.MultiValue>
    );
  }

  let displayText = data.label;
  if (showEllipsis) {
    const words = data.label.split(" ");
    displayText =
      words[0].length > truncateLength
        ? words[0].slice(0, truncateLength) + ".."
        : words[0] + "..";
  }
  if (showEllipsis) {
    if (index >= maxDisplayedItems) {
      return index === maxDisplayedItems ? <Styles>...</Styles> : null;
    }
  }

  return (
    <components.MultiValue {...props}>
      <span>{displayText}</span>
    </components.MultiValue>
  );
};
